import { Modal as LibModal } from "react-bootstrap";
import { createPortal } from "react-dom";
import "./Modal.scss";
import { i18n } from "app/i18n/i18n";

const Modal = ({
  visible,
  headerTitle,
  onClickModalHeader,
  children,
  footerLeftButton,
  footerRightButton,
  width,
  topOffset,
}) => {
  const style = {
    maxWidth: width,
    marginTop: topOffset,
  };
  const hasFooterButton = footerLeftButton || footerRightButton;
  const lang = i18n.getLanguage();
  return (
    visible &&
    createPortal(
      <div className="modal-container" lang={lang}>
        <LibModal.Dialog style={style}>
          <LibModal.Header closeButton onClick={onClickModalHeader}>
            <LibModal.Title>{headerTitle}</LibModal.Title>
          </LibModal.Header>
          <LibModal.Body>{children}</LibModal.Body>
          {hasFooterButton && (
            <LibModal.Footer>
              {footerLeftButton}
              {footerRightButton}
            </LibModal.Footer>
          )}
        </LibModal.Dialog>
      </div>,
      document.body,
    )
  );
};

export default Modal;
